import { apiAdmin } from './cliente';

// GET /api/v1/usuarios/me — dados do usuário autenticado (tenants, role)
export const obterUsuarioMe = () => apiAdmin.get('/api/v1/usuarios/me');

// PUT /api/v1/usuarios/me/idioma — atualiza idioma preferido do usuário autenticado { idioma }
export const atualizarMeuIdioma = (idioma) => apiAdmin.put('/api/v1/usuarios/me/idioma', { idioma });
